import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchChangePassword = async (username, currentPassword, newPassword) => {
    const method = "PATCH";
    const path = USERS.changePassword.replace(
        "{username}",
        encodeURIComponent(username)
    );

    // obtén el token de localStorage
    const loginData = localStorage.getItem("logindata");
    const token = loginData ? JSON.parse(loginData).data?.token : null;
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const body = { currentPassword, newPassword };

    const response = await ApiRequestInterceptor(path, method, body, headers);

    if (response.code === 200) {
        return response.data;
    } else {
        const msg = response.data?.error || "Error al cambiar contraseña";
        throw new Error(msg);
    }
};
